export default class {
	constructor(obj) {
		this.id = obj.id
		this.beginDate = obj.begindate
		this.endDate = obj.enddate
		this.filename = obj.filename
		this.terminated = obj.terminated
		this.selectionId = obj.selectionid
		this.error = obj.error
	}
}



// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoSelectionExportHistory.js